import PatientOverviewPAProgressProgress from 'dashboard/templates/views/Patient/PA/PatientOverviewPAProgressProgress';

export default {
  path: 'progress',
  name: 'PatientRecordPAProgressProgress',
  component: PatientOverviewPAProgressProgress,
  meta: {
    title: t => `${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.progress"')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true
  }
};
